import type { QuickDashboardProps } from './quick-dashboard.types.ts';
import { QuickDashboardTile } from './quick-dashboard-tile.tsx';
import { faCalendarDays, faChartColumn, faClock, faTableColumns, faUsersGear } from '@fortawesome/free-solid-svg-icons';
import styles from './quick-dashboard.module.scss';

export function QuickDashboard({ onClose }: QuickDashboardProps) {
  return (
    <div className={styles.container} onClick={onClose}>
      <div className={styles.dashboard}>
        <QuickDashboardTile
          title={'Status Board'}
          colour={'#825924'}
          icon={faTableColumns}
          route={'/sampling-board/status'}
        />
        <QuickDashboardTile
          title={'Planning Board'}
          colour={'#ab1318'}
          icon={faCalendarDays}
          route={'/sampling-board/planning'}
        />
        <QuickDashboardTile
          title={'Sampling Metrics'}
          colour={'#397d32'}
          icon={faChartColumn}
          route={'/sampling-metrics'}
        />
        <QuickDashboardTile
          title={'Sampling Timeline'}
          colour={'#822f67'}
          icon={faClock}
          route={'/sampling-timeline'}
        />
        <QuickDashboardTile
          className={styles.tileStretched}
          title={'Sampler Management'}
          colour={'#999'}
          icon={faUsersGear}
          route={'/sampler-management'}
        />
      </div>
    </div>
  );
}
